import { Component, OnDestroy } from "@angular/core";
import { ToastService } from "../../../shared/toast.service";
import { AdminPanelVerifyMftConnectionService } from "src/app/shared/services/admin-panel-verify-mft-connection-service";
import { VerifyMftConnectionDto } from "src/app/shared/Models/write/VerifyMftConnectionDto";
import { VerifyB2BConnectionDto } from "src/app/shared/Models/write/VerifyB2BConnectionDto";
import { Subject } from "rxjs";
import { first, takeUntil } from "rxjs/operators";

@Component({
  selector: "app-admin-panel-verify-mft",
  templateUrl: "./admin-panel-verify-mft.component.html",
  styleUrls: ["./admin-panel-verify-mft.component.scss"],
  providers: [ToastService],
})
export class AdminPanelVerifyMftComponent implements OnDestroy {
  typeMFT: string;

  typeB2B: string;
  keyB2B: string;

  constructor(
    private _service: AdminPanelVerifyMftConnectionService,
    private _toastService: ToastService
  ) {}
  destroy$ = new Subject();
  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }
  sendMftTestTrigger() {
    this._service
      .verifyMftConnection(new VerifyMftConnectionDto(this.typeMFT))
      .pipe(first())
      .subscribe(
        (res) => {
          this._toastService.showSuccesToast(
            $localize`:@@admin.verify.mft.triggered:MFT connection test has been triggered`,
            $localize`:@@general.verify.mft:MFT connection test`
          );
        },
        (err) => {
          this._toastService.showErrorToast(
            $localize`:@@validation.somethingwhentwrong:Something went wrong!`,
            $localize`:@@admin.verify.mft.somethingswrongelaborated:Somethng went wrong when triggering the mft connection test!`
          );
        }
      );
  }

  sendB2BTestTrigger() {
    this._service
      .verifyB2BConnection(
        new VerifyB2BConnectionDto(this.typeB2B, this.keyB2B)
      )
      .pipe(first())
      .subscribe(
        (res) => {
          this._toastService.showSuccesToast(
            $localize`:@@admin.verify.b2b.triggered:B2B connection test has been triggered`,
            $localize`:@@general.verify.b2b:B2B connection test`
          );
        },
        (err) => {
          this._toastService.showErrorToast(
            $localize`:@@validation.somethingwhentwrong:Something went wrong!`,
            $localize`:@@admin.verify.b2b.somethingswrongelaborated:Somethng went wrong when triggering the b2b connection test!`
          );
        }
      );
  }
}
